/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D");
import React, { type ReactNode } from 'react';
import AkHeading from '@atlaskit/heading/heading';
import Anchor from '@atlaskit/primitives/anchor';
import Box from '@atlaskit/primitives/box';
import { Box as CompiledBox } from '@atlaskit/primitives/compiled/box';
import Inline from '@atlaskit/primitives/inline';
import Stack from '@atlaskit/primitives/stack';
import Text from '@atlaskit/primitives/text';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { useRecommendedAgents } from '@atlassian/conversation-assistant-agent/controllers/agents';
import { useAtlasURL } from '@atlassian/conversation-assistant-agent/controllers/atlas-url';
import { AgentCreatedBy } from '@atlassian/conversation-assistant-agent/utils/agents';
import { FormattedMessage } from 'react-intl';
import { useAnalytics } from '@townsquare/analytics';
type AgentType = ReturnType<typeof useRecommendedAgents>['recommendedAgents'][number];
const cardStyles = xcss({
  borderWidth: 'border.width',
  borderStyle: 'solid',
  borderColor: 'color.border',
  borderRadius: 'radius.large',
  padding: 'space.200',
  cursor: 'pointer',
  transitionProperty: 'background-color',
  transitionDuration: '0.25s',
  transitionTimingFunction: 'ease-in-out',
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  textAlign: 'left',
  position: 'relative'
});
const anchorOverlayStyles = xcss({
  position: 'absolute',
  inset: 'space.0',
  borderRadius: 'radius.large',
  zIndex: 'card'
});
const agentAuthorStyles = xcss({
  zIndex: 'card',
  display: 'flex',
  alignItems: 'center'
});
const compiledCreatedByStyles = {
  root: "_1UtDYzZpcK _03SyCP1Y8M"
};
export function Agent({
  siteId,
  ...agent
}: {
  siteId: string;
} & AgentType): React.JSX.Element {
  const analytics = useAnalytics();
  const {
    atlasURL
  } = useAtlasURL(siteId);
  return <Box testId={`agent-browse-card-${agent.id}`} xcss={cardStyles}>
			<Anchor xcss={anchorOverlayStyles} href={atlasURL(`/people/agent/${agent.id}`)} target="_blank" onClick={() => void analytics.ui('browseAgentCard', 'clicked', {
      agentId: agent.id
    })} testId={`agent-browse-card-${agent.id}-clickable`} />
			<Stack grow="fill" space="space.200" spread="space-between">
				<Inline space="space.100" alignInline="start" alignBlock="center">
					<AgentAvatar agentNamedId={agent.external_config_reference ?? agent.named_id} agentId={agent.id} agentIdentityAccountId={agent.identity_account_id} size="medium" isForgeAgent={agent.creator_type === 'FORGE'} forgeAgentIconUrl={agent.icon} />
					<Stack>
						<AkHeading size="xsmall" as="h3">
							{agent.name}
						</AkHeading>
						<Box xcss={agentAuthorStyles}>
							<FormattedMessage id="townsquare.views.directory.browse-agent-card-created-by" description="Label to indicate the creator of the agent" defaultMessage="<text>by</text> {creatorName}" values={{
              text: (chunks: ReactNode[]) => <CompiledBox xcss={compiledCreatedByStyles.root}>{chunks}</CompiledBox>,
              creatorName: <AgentCreatedBy agent={agent} siteId={siteId} simplified />
            }} />
						</Box>
					</Stack>
				</Inline>
				<Text color="color.text.subtle" maxLines={2}>
					{agent.description}
				</Text>
			</Stack>
		</Box>;
}